<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vs-popup
      class="holamundo"
      title="Kullanıcı Sil"
      :active.sync="deletePopupActive"
      v-esc="escapeDelete"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Kullanıcıyı Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          id="removeButton"
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>

    <vs-table
      id="userDataList"
      ref="table"
      :data="users"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col v-if="($isCenterBranch() || $isRegionalCenterBranch()) && isAddPermission" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Kullanıcı" position="top">
                    <vs-button
                      @click="addNewData"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button
                      @click="getExcel"
                      class="panel-action text-dark xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-download"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-2/12">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Fotoğraf</vs-button
          >
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'name' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('name')"
            >Ad</vs-button
          >
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'branchId' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('branch.Name')"
            >Şube</vs-button
          >
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Rol</vs-button
          >
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'email' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('email')"
            >Email</vs-button
          >
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Telefon</vs-button
          >
        </vs-th>
        <vs-th v-if="isRemovePermission" class="w-1/12">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >İşlem</vs-button
          >
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-2/12 img-container">
              <img
                :src="
                  tr.imageUrl
                    ? $baseUrl + '/' + tr.imageUrl
                    : require('@/assets/images/portrait/small/profile-placeholder.png')
                "
                class="user-img"
              />
            </vs-td>

            <vs-td class="w-2/12">
              <p class="font-medium truncate">{{ tr.fullName }}</p>
            </vs-td>

            <vs-td class="w-2/12">
              <p class="product-category">{{ tr.branch.name }}</p>
            </vs-td>

            <vs-td class="w-1/12">
              <p class="product-category">{{ tr.userRoles }}</p>
            </vs-td>

            <vs-td class="w-2/12">
              <p class="product-category">{{ tr.email }}</p>
            </vs-td>

            <vs-td class="w-2/12">
              <p class="product-category">{{ tr.phoneNumber }}</p>
            </vs-td>

            <vs-td v-if="isRemovePermission" class="w-1/12 whitespace-no-wrap">
              <feather-icon
                icon="TrashIcon"
                v-if="(!$isSuperAdminById(tr.id)) && ($isCenterBranch() || $isRegionalCenterBranch())"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                "
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import PaginationDefault from "../PaginationDefault";
import DataViewSidebar from "./NewUserAdd.vue";
import moduleUser from "@/store/user/moduleUser.js";
import GlobalFilter from "../GlobalFilter";
import { deleteUser, getUserExcel } from "@/api/User";
import {isGranted} from "@/utils/auth";
/* eslint-disable */
export default {
  components: {
    DataViewSidebar,
    PaginationDefault,
    GlobalFilter,
  },
  data() {
    return {
      deletePopupActive: false,
      deletedId: null,
      selected: "",

      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      addNewDataSidebar: false,
      sidebarData: {},

      isFilterActive: false,
      filterOptions: [
        "personal",
        "branch",
        "role",
        "userName",
        "userEmail",
        "userPhoneNumber",
        "userTcNumber",
      ],
      filterOptionNames: [
        "Kullanıcı",
        "İsim",
        "Rol",
        "Kullanıcı Adı",
        "Email",
        "Telefon",
        "T.C",
      ],
      filterChips: [],
    };
  },
  computed: {
    isAddPermission(){
      return isGranted("user_write")
    },
    isRemovePermission(){
      return isGranted("user_remove")
    },
    users() {
      return this.$store.state.user.users;
    },
    totalDataRow() {
      return this.$store.state.user.totalDataRow;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    getExcel() {
      getUserExcel(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Kullanıcı Listesi" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Name",
        sortDirection: "asc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: null,
        role: null,
        userEmail: null,
        userPhoneNumber: null,
        userName: null,
        personal: null,
        userTcNumber: null,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    escapeDelete() {
      if (this.deletePopupActive == true) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    lazyFilter: _.debounce(function (e) {
      this.tableOptions[this.tableOptions.filterColumn] =
        this.tableOptions.filterValue;
      this.tableOptions.pageIndex = 0;
      this.getUserList();
    }, 600),
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      deleteUser(id).then((res) => {
        if (res && res.status == 200) {
          this.$store.dispatch("user/removeUser", id).then((data) => {
            this.deletePopupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Silme İşlemi",
              text: "Kullanıcı Başarıyla Silindi",
            });
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
        }
      });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    getUserList() {
      if (this.$isRegionalCenterBranch()) {
        this.$store
        .dispatch("user/fetchDataListItemsUserForDealer", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      } else {
        this.$store
        .dispatch("user/fetchDataListItemsUser", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      }
      
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created() {
    if (!moduleUser.isRegistered) {
      this.$store.registerModule("user", moduleUser);
      moduleUser.isRegistered = true;
    }
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
    this.clearFilter();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getUserList();
        });
      },
    },
    deletePopupActive(val) {
      if (val) document.getElementById("removeButton").focus();
    },
    selected: function (val) {
      if (this.isAddPermission) {
        val != "" ? this.editData(val) : null;
      }
    },
    currentPage: function () {
      this.tableOptions.pageIndex = this.currentPage;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>
<style>
#userDataList .con-tablex {
  max-height: calc(100vh - 215px);
  overflow-y: auto;
}
</style>
